import React, { useState } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useEffectX } from 'use-effect-x'
import configData from './../config.json'
import { Loader } from 'rsuite'

const FilesFromCategory = ({category}) => {

  const [ loading, setLoading ] = useState(true)
  
  const [ files, setFiles ] = useState(null)

  const { i18n } = useTranslation()
  const lang = i18n.language
  
  useEffectX(
    ({changedItem: [filesObj]}) => {
      if (filesObj.isFirstRun) {
        // get files
        axios.get(`${configData['REST_URL']}/acf/v3/files/`)
          .then(data => {
            const filesFromCat = data.data.filter(file => {
              return file.acf.category.includes(category)
            })
            setFiles(filesFromCat)
            setLoading(false) 
          })     
      }
    }, [files]
  )

  return (
    <div className="files-list">
      {loading && (
        <div style={{ height: 100, position: 'relative' }}>
          <Loader size="md" center/>
        </div>
      )}
      {files && (
        files.map(file => (
          <div className="wp-block-file">
            <a href={file.acf.file.url}>
              <span>{file.acf.names[`name_${lang}`]}</span>
              <span className="file-name">{file.acf.file.filename}</span>
              </a>
          </div>
        ))
      )}
    </div>
  )
}

export default FilesFromCategory